import { parse, stringify } from 'uuid';
export var RecordType;
(function (RecordType) {
    RecordType["ANNOTATION"] = "ANNOTATION";
    RecordType["EXAMPLE"] = "EXAMPLE";
    RecordType["PARAMETER"] = "PARAMETER";
    RecordType["SAMPLE"] = "SAMPLE";
})(RecordType || (RecordType = {}));
export class BaseRecord {
    id;
    type;
    logicalType;
    metadata;
    retracted;
    constructor(id, recordType, logicalType, metadata, retracted) {
        if (retracted != undefined && recordType != RecordType.ANNOTATION) {
            // TODO this could be added to the signature
            throw new TypeError('Retracted field is only accepted for ANNOTATION records');
        }
        this.id = stringify(parse(id));
        this.type = recordType;
        this.logicalType = logicalType;
        this.metadata = metadata || new Map();
        this.retracted = retracted;
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQmFzZVJlY29yZC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy9saWIvdHlwZXMvcmVjb3JkL0Jhc2VSZWNvcmQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUFFLEtBQUssRUFBRSxTQUFTLEVBQUUsTUFBTSxNQUFNLENBQUE7QUFPdkMsTUFBTSxDQUFOLElBQVksVUFLWDtBQUxELFdBQVksVUFBVTtJQUNwQix1Q0FBeUIsQ0FBQTtJQUN6QixpQ0FBbUIsQ0FBQTtJQUNuQixxQ0FBdUIsQ0FBQTtJQUN2QiwrQkFBaUIsQ0FBQTtBQUNuQixDQUFDLEVBTFcsVUFBVSxLQUFWLFVBQVUsUUFLckI7QUFFRCxNQUFNLE9BQWdCLFVBQVU7SUFDOUIsRUFBRSxDQUFRO0lBQ1YsSUFBSSxDQUFZO0lBQ2hCLFdBQVcsQ0FBYztJQUN6QixRQUFRLENBQVU7SUFDbEIsU0FBUyxDQUFhO0lBRXRCLFlBQ0UsRUFBVSxFQUNWLFVBQXNCLEVBQ3RCLFdBQXlCLEVBQ3pCLFFBQW1CLEVBQ25CLFNBQXNCO1FBRXRCLElBQUksU0FBUyxJQUFJLFNBQVMsSUFBSSxVQUFVLElBQUksVUFBVSxDQUFDLFVBQVUsRUFBRTtZQUNqRSw0Q0FBNEM7WUFDNUMsTUFBTSxJQUFJLFNBQVMsQ0FDakIseURBQXlELENBQzFELENBQUE7U0FDRjtRQUVELElBQUksQ0FBQyxFQUFFLEdBQUcsU0FBUyxDQUFDLEtBQUssQ0FBQyxFQUFFLENBQUMsQ0FBQyxDQUFBO1FBQzlCLElBQUksQ0FBQyxJQUFJLEdBQUcsVUFBVSxDQUFBO1FBQ3RCLElBQUksQ0FBQyxXQUFXLEdBQUcsV0FBVyxDQUFBO1FBQzlCLElBQUksQ0FBQyxRQUFRLEdBQUcsUUFBUSxJQUFJLElBQUksR0FBRyxFQUFFLENBQUE7UUFDckMsSUFBSSxDQUFDLFNBQVMsR0FBRyxTQUFTLENBQUE7SUFDNUIsQ0FBQztDQUNGIn0=